export enum EditProfileTab {
  PERSONAL_DETAILS,
  PROFILE_DETAILS,
  LOCATION_DETAILS,
  INTERESTS_PERSONAL,
  INTERESTS_PROFESSIONAL,
}
